import { runFormFunction } from "../input/inputFunction";
import { ClipboardProp, DataParams, TransitionType } from "../layoutType";
const dv = require("@datas/default.json");

export const equipClipboard = (formFunction: Record<string, Record<string, Function>> | undefined): ClipboardProp => {
  return {
    category: "EquipList",
    exField: ["cafe_seq", "roaster_seq", "cafe_equip_seq", "roaster_equip_seq"],
    load: (obj) => {
      runFormFunction(formFunction, ["equip_seq"], "changeLoad");
    },
  };
};
export const roastingProfileClipboard: ClipboardProp = {
  category: "RoastingProfile",
  exField: ["roaster_seq", "cupnote_seq", "roasting_start_time"],
  load: (data: any) => {},
};

export const brewingClipboard: ClipboardProp = {
  category: "BrewingCommon",
  exField: ["roaster_seq", "brewing_seq", "cupnote_seq"],
  load: (obj) => {
    // const list = ["greenbean_region_seq", "greenbean_farm_seq", "greenbean_default_seq"];
    // list.forEach((item) => {
    // });
    //   runFormFunction(formFunction?.current, ["greenbean_region_seq", "greenbean_farm_seq", "greenbean_default_seq"], "changeLoad");
  },
};
